import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/services/courses/[id]/course-details.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/services/courses/components/CourseContentAccordion.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/services/courses/components/CourseDetailClientFallback.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/services/courses/components/CourseJoinBlock.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/services/courses/components/CourseJoinNavButtons.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/services/courses/components/CourseSubscriberCount.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/services/courses/components/CourseVideoPlayer.jsx");
